import { IconButton, Tooltip } from "@chakra-ui/react";
import { FaQuestionCircle } from "react-icons/fa";
import * as React from "react";

function QuestionIconTooltip({
                               label,
                               ariaLabel,
                               fontSize = "md",
                               iconSize = 20,
                               placement = "bottom",
                               ...rest
                             }) {
  return (
    <Tooltip
      label={label}
      whiteSpace={"pre-line"}
      hasArrow
      fontSize={fontSize}
      placement={placement}
    >
      <IconButton
        aria-label={ariaLabel}
        type="button"
        icon={<FaQuestionCircle size={iconSize} />}
        flexShrink="0"
        size="sm"
        opacity="0.25"
        tabIndex={-1}
        {...rest}
      />
    </Tooltip>
  );
}

export default QuestionIconTooltip;